import { useEffect, useState } from 'react';

const matches = (query: string, fallback: boolean): boolean => (
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback
);

/** Whether the viewport matches `query`; `fallback` is used where matchMedia is unavailable (tests, SSR). */
export const useMediaQuery = (query: string, fallback = true): boolean => {
  const [value, setValue] = useState(() => matches(query, fallback));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const list = window.matchMedia(query);
    const update = () => setValue(list.matches);

    update();
    list.addEventListener('change', update);

    return () => list.removeEventListener('change', update);
  }, [query]);

  return value;
};
